import './index.scss';

(function ($) {
  'use strict';

  const sendEmail = $button => {
    $button.addClass('disabled').css('pointer-events', 'none');

    Thor.User.send_email_confirmation({ user_id: currentUser.id }, {})
      .then(() => {
        $button.parent().html($button.data('already-sent'));
      })
      .catch(() => {
        $button.removeClass('disabled').css('pointer-events', '');
        $button
          .parent()
          .append(
            '<span class="text-danger ml-2">Erro ao enviar. Tente novamente.</span>'
          );
      });
  };

  $(document)
    .off('click.notification_bar_button', '.js-send-email')
    .on('click.notification_bar_button', '.js-send-email', event => {
      event.preventDefault();
      event.stopPropagation();
      const $button = $(event.currentTarget);

      sendEmail($button);
    });
})(jQuery);
